import { createSlice, current } from "@reduxjs/toolkit";
import { add_unique_item_ids, getUnavailableProductIds } from '../helper';
import { v4 } from 'uuid'
// required:  define initial state for cart module
export const cartInitialState = {
    combo: [],
    product: [],
    totalPrice: 0,
    unavailableProducts: []
}

// required:  create slice for cart module with required reducers (actions)
export const cartSlice = createSlice({
    name: "cart",
    initialState: cartInitialState,
    reducers: {
        insertItems: (state, action) => {
            let stateData = current(state);
            // stateData = add_unique_item_ids(stateData);
            let newArray = JSON.parse(JSON.stringify(stateData.product));
            newArray.push({
                ...action.payload,
                is_available:1,
                secondary_id: v4()
                });
            stateData.totalPrice += action.payload.finalPrice;
            state.product = newArray;
            if(state.product.length === 0 && state.combo.length === 0 ){
                state.totalPrice = 0
            }
        },
        quantityPlus: (state, action) => {
            const { payload } = action;
            let stateData = current(state);
            if (payload.isCombo) {
                let newArray = JSON.parse(JSON.stringify(stateData.combo));
                let secondary_id = action.payload.secondary_id;

                const index = newArray.findIndex((item) => item.secondary_id === secondary_id);
                newArray[index].bought_count += 1;
                stateData.totalPrice += newArray[index].finalPrice;
                state.combo = newArray;
            }
            else {
                let secondary_id = action.payload.secondary_id;
                let newArray = JSON.parse(JSON.stringify(stateData.product));
                let index = newArray.findIndex((item) => item.secondary_id === secondary_id);
                if(!action.payload.is_customizable_group ){
                    index = newArray.findIndex((item) => item.product_id === payload.product_id);
                }
                if(index<0){
                    return 
                }
                newArray[index].quantity += 1;
                stateData.totalPrice += newArray[index].finalPrice;
                state.product = newArray;
            }
            if(state.product.length === 0 && state.combo.length === 0 ){
                state.totalPrice = 0
            }
        },
        quantityMinus: (state, action) => {
            const { payload } = action;
            let stateData = current(state);
            if (payload.isCombo) {
                let newArray = JSON.parse(JSON.stringify(stateData.combo));
                let secondary_id = action.payload.secondary_id;
                let index = newArray.findIndex((item) => item.secondary_id === secondary_id);

                if(!action.payload.is_customizable_group ){
                    index = newArray.findIndex((item) => item.product_id === payload.product_id);
                }
                if(index<0){
                    return 
                }
                stateData.totalPrice -= newArray[index].finalPrice;
                if (newArray[index].bought_count === 1) {
                    newArray.splice(index, 1);
                } else {
                    newArray[index].bought_count -= 1;
                }
                state.combo = newArray;
            }
            else {
                let newArray = JSON.parse(JSON.stringify(stateData.product));
                let secondary_id = action.payload.secondary_id;
                let index = newArray.findIndex((item) => item.product_id === payload.product_id);
                if(action.payload.is_customizable_group && secondary_id){
                    index = newArray.findIndex((item) => item.secondary_id === secondary_id);
                }
                stateData.totalPrice -= newArray[index].finalPrice;
                if (newArray[index].quantity === 1) {
                    newArray.splice(index, 1);
                } else {
                    newArray[index].quantity -= 1;
                }
                state.product = newArray;
            }
            if(state.product.length === 0 && state.combo.length === 0 ){
                state.totalPrice = 0
            }
        },
        removeItem: (state, action) => {
            const { payload } = action;
            if (payload.isCombo) {
                let stateData = current(state);
                let newArray = JSON.parse(JSON.stringify(stateData.combo));
                let secondary_id = action.payload.secondary_id;
                const index = newArray.findIndex((item) => item.secondary_id === secondary_id);
                stateData.totalPrice -= newArray[index].finalPrice;
                newArray.splice(index, 1);
                state.combo = newArray;
            }
            else {
                let stateData = current(state.product);
                let newArray = JSON.parse(JSON.stringify(stateData));
                let secondary_id = action.payload.secondary_id;
                let index = newArray.findIndex((item) => item.secondary_id === secondary_id);

                if(!action.payload.is_customizable_group ){
                    index = newArray.findIndex((item) => item.product_id === payload.product_id);
                }                
                stateData.totalPrice -= newArray[index].finalPrice;
                newArray.splice(index, 1);
                state.product = newArray;
            }
            if(state.product.length === 0 && state.combo.length === 0 ){
                state.totalPrice = 0
            }
        },
        updateCustomization: (state, action) => {
            const { payload } = action;
            let stateData = current(state);
            let newArray = JSON.parse(JSON.stringify(stateData.product));
            let secondary_id = action.payload.secondary_id;
            const index = newArray.findIndex((item) => item.secondary_id === secondary_id);
            let price = stateData.totalPrice;
            price -= newArray[index].finalPrice;
            price += payload.finalPrice;
            stateData.totalPrice = price;
            newArray[index] = {
                ...payload,
                is_available:1
            };
            state.product = newArray;
            if(state.product.length === 0 && state.combo.length === 0 ){
                state.totalPrice = 0
            }
        },
        updateComboCustomization: (state, action) => {
            const { payload } = action;
            let stateData = current(state);
            let newArray = JSON.parse(JSON.stringify(stateData.combo));
            let mainIndex;
            let setIndex;
            let productIndex;
            newArray.forEach((item, index) => {
                mainIndex = index
                item.sets.forEach((setD, setK) => {
                    setIndex = setK;
                    setD.products.forEach((proD, proK) => {
                        productIndex = (proD.product_id === payload.product_id ? proK : productIndex)
                    })
                })
            });

            // let price = stateData.totalPrice;

            // price -= newArray[mainIndex].sets.price;
            // price += payload.price;
            // stateData.totalPrice = price;
            newArray[mainIndex].sets[setIndex].products[productIndex] = payload;
            state.combo = newArray;
            if(state.product.length === 0 && state.combo.length === 0 ){
                state.totalPrice = 0
            }
        },
        insertCombo: (state, action) => {
            let stateData = current(state);
            let newArray = JSON.parse(JSON.stringify(stateData.combo));
            newArray.push(action.payload);
            stateData.totalPrice += action.payload.price;
            state.combo = newArray;
            if(state.product.length === 0 && state.combo.length === 0 ){
                state.totalPrice = 0
            }
        },
        resetCartItems: (state, action) => {
            state.combo = [];
            state.product = [];
            state.totalPrice = 0;
        },
        setUnavailableProducts: (state,{payload})=>{
            const pids = getUnavailableProductIds({brands:payload.brands})
            state.product = state.product.map(prod=>{
                const is_available = pids.includes(prod.product_id)? 0 : 1;
                if(!is_available){
                    state.totalPrice -= prod.finalPrice;                    
                }
                return {
                    ...prod,
                    is_available 
                }
            })
        },
        removeUnavailableProducts: (state,action)=>{
            state.product = state.product.filter(prod=>prod.is_available);
            state.unavailableProducts = []
        }
    },
});

// required: export all defined reducer functions as actions
export const {
    insertItems,
    quantityPlus,
    quantityMinus,
    updateCustomization,
    insertCombo,
    updateComboCustomization,
    resetCartItems,
    removeItem,
    setUnavailableProducts,
    removeUnavailableProducts
} = cartSlice.actions;

// required: export complete reducer
export default cartSlice.reducer;
